import React from 'react';
import PropTypes from 'prop-types';
import { Col, Row } from 'grab-ui';
import OngoingOrderSection from './ongoing-order-section';
import RecentUpdateSection from './recent-update-section';

const OngoingSections = ({ goToBookingsTab }) => (
  <Row type="flex">
    <Col md={16} xs={24} sm={24}>
      <OngoingOrderSection goToBookingsTab={goToBookingsTab} />
    </Col>
    <Col md={8} xs={24} sm={24}>
      <RecentUpdateSection goToBookingsTab={goToBookingsTab} />
    </Col>
  </Row>
);

OngoingSections.propTypes = {
  goToBookingsTab: PropTypes.func.isRequired,
};

export default OngoingSections;
